export default __webpack_public_path__ + "static/media/bus_c5.475883a6.svg";